// src/guards/OnboardingGuard.jsx - Onboarding Protection Guard
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const OnboardingGuard = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Check if onboarding is completed
  const onboardingCompleted = currentUser?.onboarding_completed ?? false;

  // If not completed, redirect to onboarding
  if (!onboardingCompleted) {
    console.log('🚨 Onboarding not completed, redirecting to /onboarding');
    return <Navigate to="/onboarding" state={{ from: location }} replace />;
  }

  // Onboarding completed, render children
  return children;
};

export default OnboardingGuard;
